import React, { Component } from 'react';
import './Header.css'

class Header extends Component {
    render() {
        return (
            <section class="category_banner">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 category_bannertext">
                            <h1>Growth Partnership</h1>
                            <p>Our strategic consulting services help clients identify problem areas, formulate solutions, and implement them, thus facilitating and supporting our clients with their growth initiatives. We also cater to ongoing monitoring of the growth process to help you maximize your opportunities.</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }


}


export default Header;


// WEBPACK FOOTER //
// ./src/consulting/GrowthPatnership/Header/Header.js